export default "__VITE_ASSET__BF8hE_NK__"